import { type BoundingBox } from "../../../../../pages/extraction/viewExtraction/FileViewer";
import { type AuditSession } from "../../../../../models/audit/auditSession";
import {
  Citation,
  extractTimestampFromCitationString,
} from "../../../../../models/audit/citation";

export interface BoundingBoxState {
  boundingBox?: BoundingBox;
  pageNumber?: number;
  pageWidth?: number;
  pageHeight?: number;
  elementId?: string;
  citationId?: string;
  timestampSeconds?: number;
}

/**
 * Project a citation onto the doc-viewer's `BoundingBoxState` — the box, page
 * geometry, and the element/citation ids the viewer keys off. The timestamp is
 * the citation's own (video) or, failing that, parsed from its encoded string.
 * Shared by the fold-outs and the highlight hooks so the projection lives in one
 * place.
 */
export function citationToBoundingBox(citation: Citation): BoundingBoxState {
  return {
    boundingBox: citation.boundingBox ?? undefined,
    pageNumber: citation.pageNumber ?? undefined,
    pageWidth: citation.pageWidth ?? undefined,
    pageHeight: citation.pageHeight ?? undefined,
    elementId: citation.encodedCitationString ?? undefined,
    citationId: citation.id ?? undefined,
    timestampSeconds:
      citation.timestampSeconds ??
      extractTimestampFromCitationString(citation.encodedCitationString || ""),
  };
}

export interface CitationDocument {
  document: AuditSession["documents"][number];
  citations: Citation[];
}
